module.exports = __webpack_public_path__ + "static/media/alumni-success--hero.f03f7c4f.jpg";